import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExcelExporterVariable  {
    _originalTypeClassName = "zERP.BO.ExcelExporterVariable";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExcelExporterVariable.translate = translateService;
}
this.Children = [];
this.Name = null;
this.Description = null;
this.Value = null;
this.DecimalValue = null;
this.IsCollection = false;
this.DefaultValue = null;
this.Type = null;
this.ExcelExporterVariableKey = null;
this._key = this.ExcelExporterVariableKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
Description:any;
Value:any;
DecimalValue:any;
IsCollection:any;
DefaultValue:any;
Type:any;
Children:any;
private _ExcelExporterVariableKey:any;
get ExcelExporterVariableKey(): any {
    return this._ExcelExporterVariableKey;
  }
set ExcelExporterVariableKey(value: any) {
    this._ExcelExporterVariableKey = value;
    this._key = value;
  }
static setChildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.Children == null) $this.Children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Children.length > 0) {
                    Domain.ExcelExporterVariable.removeChildren($this, $this.Children[0]);
                }

                Domain.ExcelExporterVariable.addManyChildren($this, copyItems);
            }
static addManyChildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ExcelExporterVariable.addChildren($this, items[i]);
                }
            }
static addChildren = ($this, item) => {
                if ($this.Children == null) $this.Children = [];
                if (item == null || $this.Children.indexOf(item) > -1) return;
                $this.Children.push(item);
}
static addRangeChildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ExcelExporterVariable.addChildren($this, item));
            }
static removeChildren = ($this, item) => {
                if ($this == null || $this.Children == null || $this.Children.indexOf(item) === -1) return;
                var _index = $this.Children.indexOf(item);
                $this.Children.splice(_index, 1);
}
static clearChildren = ($this) => { $this.Children = null; }

static GetValue($this: any, preview: any): any{if (preview) {return $this?.DefaultValue;}
if (!(CLMS.Framework.String.IsNullOrEmpty(($this?.Value ?? '').trim()))) {return $this?.Value;}
return $this?.DecimalValue;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ExcelExporterVariableKey == null || $this.ExcelExporterVariableKey == 0;
            }


}